<script>
import { adminMenu } from "@/utils/menus.js";
import { findNotifications } from "@/services/notification-api";

export default {
  name: "HeaderScreen",
  data() {
    return {
      menuItems: [],
      userFullName: this.getCookie("ufn") || "Utilisateur",
      userPrivilege: this.getCookie("up") || null,
      isMenuOpen: false,

      notifications: [],
      unreadNotificationCount: 0,
      notificationInterval: null,

      mainPageModel:{page:1, pageSize:3},


    };
  },

  mounted() {
    this.loadMenu();
    this.fetchNotifications();
    this.notificationInterval = setInterval(() => {
      this.fetchNotifications();
    }, 30000);
  },
  beforeUnmount() {
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
  },


  methods: {

    goToDetailsPage(documentId) {
      if (!documentId) return
      
      if (
        this.$route.path == '/details' &&
        this.$route.query.id == documentId
      ) {
        return
      }

      this.$router.push({
        path: '/details',
        query: { id: documentId }
      })
      
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    },

    loadMenu() {
      this.menuItems = adminMenu(this.userPrivilege);
    },

    goToProfile() {
      this.$router.push("/profile");
    },

    logout() {
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      });
      this.$router.push("/login");
    },



    //API CALL

    async fetchNotifications() {
      const params = {
        page: this.mainPageModel.page,
        pageSize: this.mainPageModel.pageSize,
      };

      const result = await findNotifications(params);
      this.notifications = result.content;
      this.mainPageModel.total = result.totalElements;
      this.mainPageModel.totalPages = result.totalPages;
      this.mainPageModel.page = result.pageNumber;
      this.unreadNotificationCount = result.unreadNotificationCount;
    },

  },
};
</script>

<template>
  <header class="text-white" style="background-color: #e1dac8;">
    <!-- Top Header -->
    <div class="container py-2">
      <div class="row align-items-center">
        <!-- Logo -->
        <div class="col-md-3 col-sm-4 col-6">
          <img
            src="@/assets/images/logo_owner.png"
            alt="SofTime Logo"
            class="logo img-fluid"
            style="height: 40px; width: auto;"
          />
        </div>

        <div class="col-md-9 col-sm-8 col-6 d-flex justify-content-end align-items-center user-dropdown-wrapper">


          <b-dropdown
            variant="link"
            toggle-class="notification-toggle"
            no-caret
            right
          >
            <template #button-content>
              <div class="notification-icon-wrapper">
                <img src="@/assets/icons/bell-alt.svg" height="20" />
                <span 
                  v-if="unreadNotificationCount > 0"
                  class="notification-dot"
                ></span>
              </div>
            </template>

            <div class="notification-menu">

              <!-- Empty State -->
              <div v-if="notifications.length === 0" class="empty-state">
                <i class="bi bi-bell-slash"></i>
                <p>Aucune notification</p>
              </div>

              <!-- Notifications -->
              <div
                v-for="(notif, index) in notifications"
                :key="index"
                class="notification-item"
              >
                <div :class="notif.read ? 'readNotification-content' : 'notification-content'" style="cursor: pointer;" @click="goToDetailsPage(notif.documentId)">
                  <div class="notification-title">
                    {{ notif.object }}
                  </div>
                  <div class="notification-message">
                    {{ notif.message }}
                  </div>
                  <div class="notification-time">
                    {{ notif.timestamp }}
                  </div>
                </div>
              </div>

              <div
                v-if="mainPageModel.totalPages > 1"
                class="pagination-wrapper d-flex align-items-center justify-center gap-2 py-1 px-2"
                style="background: #f8f9fa; border-radius: 8px; font-size: 0.85rem;"
              >
                <div
                  class="page-arrow"
                  :class="{ disabled: mainPageModel.page <= 1 }"
                  @click="mainPageModel.page > 1 && (mainPageModel.page--, fetchNotifications())"
                >
                  &lsaquo;
                </div>

                <div class="page-number mx-2">
                  Page {{ mainPageModel.page }} / {{ mainPageModel.totalPages }}
                </div>

                <div
                  class="page-arrow"
                  :class="{ disabled: mainPageModel.page >= mainPageModel.totalPages }"
                  @click="mainPageModel.page < mainPageModel.totalPages && (mainPageModel.page++, fetchNotifications())"
                >
                  &rsaquo;
                </div>
              </div>

            </div>
          </b-dropdown>


          <!-- User dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="text-white p-0 d-flex align-items-center ml-3"
            no-caret
            right
          >
            <template #button-content>
              <img src="@/assets/icons/user-dark.svg" alt="User" height="20" class="mr-2"/>
              <span class="user-name text-dark d-none d-sm-inline" style="font-weight: 550;">
                {{ userFullName }}
              </span>
            </template>

            <b-dropdown-item @click="logout">
              <img src="@/assets/icons/logout-svgrepo-com.svg" height="25" class="mr-2"/>
              <span class="text-warning text-uppercase"> Se déconnecter</span>
            </b-dropdown-item>
          </b-dropdown>

        </div>
      </div>
    </div>

  <b-navbar toggleable="lg" type="light" variant="white" class="shadow-sm">
      <b-container>

      <b-navbar-toggle class="navbar-toggle" target="nav-collapse">
        <div class="hamburger" :class="{ open: isMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="mx-auto">

          <template v-for="(item, index) in menuItems">
          
            <b-nav-item-dropdown
              v-if="item.children"
              :key="index"
              :text="item.name"
              class="text-uppercase mx-3"
              right
            >
              <b-dropdown-item
                v-for="(child, cIndex) in item.children"
                :key="cIndex"
                :to="child.path"
              >
                {{ child.name }}
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item
              v-else
              :key="item.path"
              :to="item.path"
              class="text-uppercase mx-3"
            >
              {{ item.name }}
            </b-nav-item>

          </template>

        </b-navbar-nav>
      </b-collapse>

    </b-container>
  </b-navbar>

  </header>
</template>


<style scoped>

.navbar-light .nav-link:hover,
.navbar-light .active .nav-link {
  color: #010101 !important;
}

.dropdown-menu {
  border-radius: 0.35rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.custom-dropdown {
  min-width: 220px;
  border-radius: 0.5rem;
  border: none;
  padding: 0.2rem 0;
}

.custom-dropdown-item {
  padding: 5px 20px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .dropdown-item:hover{
  background-color: white;
  color: #1387e1;
}

::v-deep .nav-link{
  background-color: white !important;
  color: #010101 !important;
  border: none !important;
}

::v-deep .nav-link:focus{
  background-color: white !important;
  color: #1387e1 !important;
  font-weight: 500;
}

.custom-dropdown-item:last-child {
  border-bottom: none;
}



/* Fade animation */
@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}



.user-dropdown-wrapper {
  padding-right: 10px; /* prevent edge overflow */
}

@media (max-width: 576px) {
  .user-dropdown-wrapper {
    justify-content: flex-end !important; /* Keep Right but safe */
  }

  .dropdown-menu {
    right: 0 !important;  /* Force dropdown inside the screen */
    left: auto !important;
    transform: translateX(0) !important;
  }
}


.navbar-toggle{
  border: none;
}

.hamburger {
  width: 28px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.hamburger span {
  height: 3px;
  background: #333;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* Animation when open */
.hamburger.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}
.hamburger.open span:nth-child(2) {
  opacity: 0;
}
.hamburger.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}


.mini-pagination {
  display: flex;
  align-items: right;
  justify-content: right;
  gap: 10px;
}




.notification-toggle {
  padding: 0 !important;
  display: flex;
  align-items: center;
}

.notification-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.notification-dot {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  background: #ff3b30;
  border-radius: 50%;
}

/* Dropdown Container */
.notification-menu {
  width: 340px;
  max-height: 480px;
  overflow-y: auto;
}

/* Empty */
.empty-state {
  text-align: center;
  color: #9ca3af;
  padding: 40px 0;
}

.empty-state i {
  font-size: 22px;
  margin-bottom: 10px;
}

/* Notification item */
.notification-item {
  padding: 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  margin-bottom: 8px;
}

.notification-item:hover {
  background: #f9fafb;
  transform: translateY(-2px);
}

/* Content */
.notification-title {
  font-weight: 600;
  font-size: 13px;
  color: #111827;
}

.notification-message {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

.notification-time {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 6px;
}

/* Actions */
.notification-actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}

.btn-cancel {
  border: 1px solid #e5e7eb;
  background: transparent;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 8px;
}

.btn-approve {
  background: #111827;
  color: white;
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 8px;
}

.pagination-wrapper {
  user-select: none;
  justify-content: right;
}

.page-arrow {
  font-size: 22px;
  cursor: pointer;
  color: #6c757d;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.2s;
}

.page-arrow:hover {
  background-color: #e2e6ea;
  color: #495057;
}

.page-arrow.disabled {
  cursor: default;
  opacity: 0.4;
}

.page-number {
  font-weight: 500;
  color: #343a40;
  min-width: 40px;
  text-align: center;
}


.readNotification-content {
  opacity: 0.65;
  transition: all 0.2s ease;
}

.readNotification-content .notification-title {
  font-weight: 500;
  color: #6b7280; /* softer gray */
}

.readNotification-content .notification-message {
  color: #9ca3af;
}

.readNotification-content .notification-time {
  color: #d1d5db;
}


</style>